<template>
	<div class="flash-message alert" v-bind:class="flashClass">
		<strong>{{options.message}}</strong>
		<span>{{options.messageDetails}}</span>
	</div>
</template>

<script>
	export default {
		name: 'flash',
		props: ['options'],
		computed: {
			flashClass () {
				return `alert-${this.options.type || 'info'}`
			}
		}
	}
</script>
